module.exports = __webpack_public_path__ + "static/media/temp-program-2.0e7b0bb1.png";